// extracted by mini-css-extract-plugin
module.exports = {"ellipses":"ContentCardSigns_ellipses__1Z4sG"};